<!--
 * @Author: ZS
 * @Date: 2020-06-15 10:14:28
 * @LastEditors: ZS
 * @LastEditTime: 2020-06-15 10:49:22
 * @Description: file content
-->
<template>
  <div
    class="tip-wrap"
    :class="{ anim: animate == true }"
    @mouseover="stopScroll"
    @mouseleave="startScroll"
    style="height: 100%"
  >
    <template v-if="userTip.length === 0">
      <div style="text-align: center; height: 100%">
        <img
          src="../../../../static/images/empty.png"
          alt=""
          style="max-height: 100%"
        />
      </div>
    </template>
    <template v-else>
      <div
        class="usertip noselect"
        v-for="(item, index) in userTip"
        :key="index"
      >
        <!-- <span :class="{pass:item.status == 1}">
        <i class="iconfont icon-icon_notice"></i>
        {{item.statusText}}：
      </span>
      <b>{{item.sxName}}</b>
      <div class="time pull-right">{{item.time}}</div> -->
        <span class="pass">
          <i class="iconfont icon-icon_notice"></i>
        </span>
        <b class="tip-title" @click="clickBtn(item)">{{
          item.guidelineName
        }}</b>
        <div class="time pull-right">{{ item.processinstancecreatetime }}</div>
      </div>
    </template>
  </div>
</template>

<script>
import { request } from "@/api/axios.js";
export default {
  props: {
    // 控制展示多少页
    num: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      userTip: [],
      // userTip: [{
      //     status: 0,
      //     sxName: '《学校官网域名申请》办理',
      //     statusText: '审批通过',
      //     time: '09-06'
      //   }, {
      //     status: 0,
      //     sxName: '《学校官网域名申请》办理',
      //     statusText: '审批通过',
      //     time: '09-07'
      //   },
      //   {
      //     status: 1,
      //     sxName: '《学校官网域名申请》办理',
      //     statusText: '审批不通过',
      //     time: '09-08'
      //   },
      //   {
      //     status: 0,
      //     sxName: '《学校官网域名申请》办理',
      //     statusText: '审批通过',
      //     time: '09-09'
      //   },
      //   {
      //     status: 0,
      //     sxName: '《学校官网域名申请》办理',
      //     statusText: '审批通过',
      //     time: '09-10'
      //   }
      // ],
      animate: false,
      start: "",
    };
  },
  mounted() {
    this.guidelineinProcess();
    // setInterval(this.scroll,2000);
    // this.start = setInterval(() => {
    //   this.scroll();
    // }, 2000);
  },
  methods: {
    /**
     * @name guidelineinProcess
     * @description 获取数据
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-09-23 09:06:52
     */
    async guidelineinProcess() {
      // /portal-ywtb/web/my/guidelineinProcess
      let res = null;
      try {
        res = await request({
          method: "post",
          url: "/portal-ywtb/web/my/guidelineinProcess",
          data: {
            pageNum: 1,
            pageSize: 10,
            processType: 2,
            // memberId: admin
            memberId: this.$store.state.userId,
          },
        });
      } catch (error) {
        console.log(error);
        return Promise.reject(error);
      }
      // console.log(res);
      this.userTip = res.dataList || [];
      if (this.userTip.length > this.num) {
        this.start = setInterval(() => {
          this.scroll();
        }, 2000);
      }
    },
    scroll() {
      this.animate = true; // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
      setTimeout(() => {
        this.userTip.push(this.userTip[0]); // 将数组的第一个元素添加到数组的
        this.userTip.splice(0, 1); //删除数组的第一个元素
        this.animate = false; // margin-top 为0 的时候取消过渡动画，实现无缝滚动
      }, 500);
    },
    stopScroll() {
      // clearInterval(this.startScroll.start)
      clearInterval(this.start);
    },
    startScroll() {
      if (this.userTip.length > this.num) {
        this.start = setInterval(() => {
          this.scroll();
        }, 2000);
      }
    },
    // 登录后点击办理事件跳转
    clickBtn(item) {
      window.open(item.taskUrl);
    },
  },
};
</script>

<style scoped>
.anim {
  transition: all 0.5s;
  margin-top: -30px;
}
.tip-wrap {
  width: calc(100% - 20px);
}
.tip-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  width: calc(100% - 155px);
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/page/home/UserTip.vue